// Admin pages each staff role may open. Super admins open everything.
// The server enforces the same split through RLS (is_staff) and edge functions.
export type StaffRole = "campaign_ops" | "account_manager";

export const STAFF_ROLE_LABELS: Record<StaffRole, string> = {
  campaign_ops: "Campaign Operations",
  account_manager: "Account Manager",
};

export const STAFF_ROLE_DESCRIPTIONS: Record<StaffRole, string> = {
  campaign_ops: "Target refill, target database, campaigns, account health, acceptance and replies",
  account_manager: "Workspace CRM, calendar, account renewals, seats, payments and customer activity",
};

export const STAFF_ALLOWED_PREFIXES: Record<StaffRole, string[]> = {
  campaign_ops: [
    "/admin/organizations",
    "/admin/target-refill",
    "/admin/target-database",
    "/admin/idle-accounts",
    "/admin/blocked-accounts",
    "/admin/connected-accounts",
    "/admin/disconnected-accounts",
    "/admin/acceptance-rate",
    "/admin/replies",
    "/admin/campaign-monitor",
    "/admin/auto-withdraw",
    "/admin/managed-campaigns",
    "/settings",
  ],
  account_manager: [
    "/admin/organizations",
    "/admin/crm-calendar",
    "/admin/account-renewals",
    "/admin/customer-activity",
    "/settings",
  ],
};

const norm = (pathname: string) => pathname.replace(/\/+$/, "") || "/";

export const isStaffAllowedPath = (pathname: string, roles: readonly string[]): boolean => {
  const p = norm(pathname);
  if (!roles.length) return false;
  if (p === "/admin") return true;
  return roles.some((r) =>
    (STAFF_ALLOWED_PREFIXES[r as StaffRole] || []).some((pre) => p === pre || p.startsWith(pre + "/")),
  );
};

/** Workspace detail tabs per role (super admins see all). */
export const STAFF_WORKSPACE_TABS: Record<StaffRole, string[]> = {
  campaign_ops: ["action", "control", "campaigns", "ai", "connections", "replies", "inbox", "job-queue", "auto-withdraw", "activity"],
  account_manager: ["crm", "control", "billing", "ai-credits", "inbox", "activity"],
};

/** Workspace detail tabs a user may see; null = all (super admin). */
export const allowedWorkspaceTabs = (roles: readonly string[]): Set<string> | null =>
  roles.length ? new Set(roles.flatMap((r) => STAFF_WORKSPACE_TABS[r as StaffRole] || [])) : null;
